export default (postalOperatorWithImpcs) => postalOperatorWithImpcs
  .map((postalOperatorWithImpc) => ({
    value: postalOperatorWithImpc.postalOperatorCode,
    label:
      (postalOperatorWithImpc.postalOperatorCode ? `${postalOperatorWithImpc.postalOperatorCode} - ` : '') + (postalOperatorWithImpc.postalOperatorName
      ? postalOperatorWithImpc.postalOperatorName : ''),
    children: [
      {
        label: (postalOperatorWithImpc.postalOperatorCode ? `${postalOperatorWithImpc.postalOperatorCode} - ` : '') + (postalOperatorWithImpc.postalOperatorName
          ? postalOperatorWithImpc.postalOperatorName : ''),
        value: postalOperatorWithImpc.postalOperatorCode,
      },
    ],
  }));
